var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.mode === 'family')?_c('DataListFamilyComponent'):_vm._e(),(_vm.mode === 'source')?_c('DataListSourceComponent'):_vm._e(),(_vm.mode === 'molecule')?_c('DataListMoleculeComponent'):_vm._e(),(_vm.mode === 'synergy')?_c('DataListSynergyComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }